<div class="w-full select-none">

  <!-- wrapper -->
  <div class="relative h-4 rounded-full bg-gray-200 ">

    <!-- GRADIENT ZONES -->
    <div class="absolute inset-0 flex">

      <!-- LOW (danger) -->
      <div
        class="bg-gradient-to-r from-[#CC110E] to-[#CC110E] opacity-80"
        [style.width.%]="minZonePercent"
      ></div>

      <!-- OK (safe zone) -->
      <div
        class="bg-gradient-to-r from-[#7BD3D6] to-[#7BD3D6] opacity-90 shadow-[0_0_10px_rgba(34,197,94,0.3)]"
        [style.width.%]="okZonePercent"
      ></div>

      <!-- HIGH (danger) -->
      <div
        class="bg-gradient-to-r from-[#CC110E] to-[#CC110E] opacity-80"
        [style.width.%]="maxZonePercent"
      ></div>

    </div>

    <!-- ticks -->
    <div class="absolute inset-0 flex items-center justify-between px-1">
      <div
        *ngFor="let t of ticks"
        class="w-px h-2 bg-black/30"
      ></div>
    </div>

    <!-- thresholds -->
    <div
      class="absolute top-1/2 -translate-y-1/2 w-0.5 h-6 bg-black/70"
      [style.left.%]="minThresholdPercent"
    ></div>

    <div
      class="absolute top-1/2 -translate-y-1/2 w-0.5 h-6 bg-black/70"
      [style.left.%]="maxThresholdPercent"

    ></div>

    <!-- THUMB -->
  <div
    class="absolute top-full -mt-1 transition-all duration-150 ease-out"
    [style.left.%]="valuePercent"
    style="transform: translateX(-50%)">
    
    <div class="relative group">

      <!-- POINTER (triangle) -->
      <span 
          class="material-symbols-outlined !text-[20px] md:!text-xl text-danger-800"
          [ngClass]="thumbColorClass">
          assistant_navigation
      </span>
      <!-- value -->
      <div
        class="absolute -top-8 left-1/2 -translate-x-1/2
              text-xs font-semibold px-2 py-1
              rounded-md bg-gray-900 text-white
              shadow-lg border border-white/10
              whitespace-nowrap">
        {{ value }} €
      </div>
  </div>
</div>

    <!-- INPUT -->
    <input
      type="range"
      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      [min]="min"
      [max]="max"
      [value]="value"
      (input)="onInput($event)"
    />

  </div>

  <!-- labels -->
  <div class="relative mt-2 text-xs text-gray-500 h-6">

  <!-- min -->
  <span class="absolute left-0 -translate-x-0">
    <!-- {{ min }} -->
  </span>

  <!-- minThreshold -->
  <span
    class="absolute -translate-x-1/2 mt-4"
    [style.left.%]="minThresholdPercent"
  >
    {{ minThreshold }} €
  </span>

  <!-- maxThreshold -->
  <span
    class="absolute -translate-x-1/2 mt-4"
    [style.left.%]="maxThresholdPercent"
  >
    {{ maxThreshold }} €
  </span>

  <!-- max -->
  <span class="absolute right-0 translate-x-0">
    <!-- {{ max }} -->
  </span>

</div>

</div>